import { format, parseISO } from 'date-fns';
import { DailyNavReportSourceRow, DailyNavValidationCompany } from 'pages/Intelligence/DailyNav/daily-nav.api.types';

export const formatWhen = (value?: string | null) => {
  if (!value) {
    return '';
  }
  try {
    return format(parseISO(value), 'MMM d, yyyy, h:mm a');
  } catch {
    return value;
  }
};

export const formatPrice = (value?: string | null, currency?: string | null) => {
  if (!value) {
    return '—';
  }
  const amount = Number(value);
  if (Number.isNaN(amount)) {
    return value;
  }
  return amount.toLocaleString('en-US', {
    style: 'currency',
    currency: currency || 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const formatDate = (value?: string | null) => {
  if (!value) {
    return '—';
  }
  try {
    return format(parseISO(value), 'MMM d, yyyy');
  } catch {
    return value;
  }
};

export const formatFailedCompany = (company: DailyNavValidationCompany, rows: DailyNavReportSourceRow[]) => {
  const row = rows.find(reportRow => reportRow.company_id === company.company_id);
  if (company.cause === 'carry_forward_mismatch' && row?.valuation_price_per_share) {
    return `${company.company_name} (today ${formatPrice(row.valuation_price_per_share, row.currency)})`;
  }
  if (company.cause === 'triggered_incomplete') {
    return `${company.company_name} (review incomplete)`;
  }
  if (company.cause === 'started_incomplete') {
    return `${company.company_name} (in progress)`;
  }
  if (company.cause === 'missing_mark') {
    return `${company.company_name} (no mark)`;
  }
  return company.company_name;
};
